
import React from 'react';
import { CardHeader, CardTitle, CardDescription } from "@/components/ui/card";
import { SparklesIcon } from "lucide-react";

const SubmissionFormHeader: React.FC = () => {
  return (
    <CardHeader>
      <CardTitle className="flex items-center text-2xl text-sunset-dark">
        <SparklesIcon className="mr-2 h-6 w-6 text-peach-orange" />
        Submit a New Terrace
      </CardTitle>
      <CardDescription className="text-base">
        Start by pasting a Google Maps link to the terrace. Our AI will automatically fill in the details, 
        which you can then review and edit before submitting.
      </CardDescription>
    </CardHeader>
  );
};

export default SubmissionFormHeader;
